// extracted by mini-css-extract-plugin
module.exports = {"rating":"RatingStars_rating__3GrM-"};